export default __webpack_public_path__ + "static/media/icon_arrow_right.9fb4605f.svg";